'use strict';

angular.module('portal.inspections')
    .controller('PortalInspectionsOverrideModal', ['$scope', '$uibModalInstance', 'inspections', function ($scope, $uibModalInstance, inspections) {

        $scope.inspections = inspections;

        $scope.yes = function () {
            $uibModalInstance.close(true);
        }

        $scope.no = function () {
            $uibModalInstance.close(false);
        }

        $scope.$on('$destroy', function () {
        });
    }])
;